module.exports = __webpack_public_path__ + "img/udogu.d2f8ab10.jpeg";